<template>
  <v-layout
    column
    wrap
    class="card-type"
    id="payment-form--CardType"
    v-if="!technologyFeeFF">
    <v-flex xs-12 :class="{ hasError: error }">
      <h2>Payment Method</h2>
      <v-radio-group @change="$emit('change', $event)" v-model="model.cardType">
        <v-radio
          color="#F7942F"
          key="CC"
          label="Credit Card"
          value="CREDIT_CARD"
          :disabled="technologyFeeFF"></v-radio>
        <v-radio
          color="#F7942F"
          key="DC"
          label="Debit Card"
          value="DEBIT_CARD"
          :disabled="technologyFeeFF"></v-radio>
      </v-radio-group>
    </v-flex>
    <v-flex>
      <span v-if="error">This field is required</span>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      model: {
        cardType: this.cardType,
      },
    };
  },
  props: {
    creditCardSurcharge: {
      type: Number,
      required: true,
    },
    cardType: {
      type: String,
      required: true,
    },
  },
  computed: {
    error() {
      return this.errors.items.find(e => e.field === 'paymentCardType');
    },
  },
  watch: {
    cardType() {
      this.model.cardType = this.cardType;
    },
  },
};
</script>

<style lang="scss">
@import '../../styles/vars/theme';

.card-type {
  .v-radio {
    label.v-label {
      margin-bottom: 0 !important;
    }
  }
  .hasError {
    border: 1px solid $theme-color-alert;
    border-radius: 5px;
  }
  span {
    display: block;
    font-size: 14px;
    padding-top: 0.4em;
    color: $theme-color-alert;
    height: 40px;
  }
}
</style>
